// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"897":"f0298378a175a477d598","974":"c5a9692a9afe371cac99"}[chunkId] + ".js";
};